import { Box, Divider, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import { WeatherType } from "~/modules/project/functions/weather";

interface WeatherReportProps {
    data: WeatherType;
    label: string;
}

export function WeatherReport({ data, label }: WeatherReportProps) {
    const { t } = useTranslation("project");

    return (
        <Box sx={{ flex: 1 / 2 }}>
            <Divider>{label}</Divider>

            <Typography>
                {t("projectVisitWorkerReport.precipitation")}: {data.precipitation ?? "-"}
            </Typography>
            <Typography>
                {t("projectVisitWorkerReport.temp")}: {data.temp !== undefined ? `${data.temp} °C` : "-"}
            </Typography>
            <Typography>
                {t("projectVisitWorkerReport.wind")}: {data.wind ?? "-"}
            </Typography>
            <Typography>
                {t("projectVisitWorkerReport.wind-direction")}: {data["wind-direction"] ?? "-"}
            </Typography>
        </Box>
    );
}
